import {
  COIN_LIST_PAGE_LOADED,
  COIN_LIST_NEXT_PAGE_LOADED,
  COIN_LIST_SEARCH_LOADED,
  COIN_LIST_PAGE_UNLOADED,
  COIN_TRANSACTION_PAGE_LOADED,
  COIN_TRANSACTION_PAGE_UNLOADED,
  COIN_SEND_LOADED,
  COIN_SEND,
  COIN_SEND_UNLOADED,
  UPDATE_FIELD_SEND,
  UPDATE_FIELD_TRANSACTION_SEARCHTERM
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
import * as _ from 'lodash'

export default (state = {}, action) => {
  switch (action.type) {
    case COIN_LIST_PAGE_LOADED:
    case COIN_LIST_SEARCH_LOADED:
    case COIN_LIST_NEXT_PAGE_LOADED:
      return {
        ...state,
        transactions: action.payload.transactions,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
      }
    case COIN_TRANSACTION_PAGE_LOADED:
      return {
        ...state,
        transaction: action.payload.transaction
      }
    case UPDATE_FIELD_SEND:
      return { ...state, [action.key]: action.value };
    case COIN_SEND_LOADED:
      return {
        ...state,
        accounts: action.payload
      }
    case COIN_SEND:
      return {
        ...state,
        redirectTo: action.error ? null : '/coins',
        errors: action.error ? action.payload.error : null,
        send_success: action.error ? false : (action.payload && action.payload.amount ? true : false),
        codeStatus: action.error ? null : action.payload ? action.payload.code_status : null,
      }
    case COIN_SEND_UNLOADED:
    case COIN_TRANSACTION_PAGE_UNLOADED:
    case COIN_LIST_PAGE_UNLOADED:
      return {}
    case UPDATE_FIELD_TRANSACTION_SEARCHTERM:
      return {
        ...state,
        [action.key]: action.value,
      }
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/coins.js